import { defineStore } from 'pinia';
import {
  ref
} from '@nuxtjs/composition-api';

export const useErrorHandlerStore = defineStore('errorHandlerStore', () => {
  const errorStates = new Map();
  const requestErrors = ref(errorStates)

  return {
    errorStates,
    requestErrors
  }
})
